module.exports = __webpack_public_path__ + "img/易耗品.9bb35347.svg";